export default __webpack_public_path__ + "static/media/or_0.1c5d2875.mp3";